// Preserve the selected frame in SSR. Neighbours load on pointer/keyboard intent,
// not merely because native lazy-loading considers horizontal slides nearby.
export function shouldLoadGallerySlide(
  index: number,
  selected: number,
  count: number,
  warmNeighbours: boolean,
) {
  if (index === 0 || index === selected) return true;
  if (!warmNeighbours || count < 2) return false;
  return index === (selected + 1) % count || index === (selected - 1 + count) % count;
}
